<template>
  <el-dialog
    :visible.sync="editValiate"
    :title='editType === "手机" ? $t("accountI18n.phone") : editType === "邮箱" ? $t("accountI18n.email") : $t("accountI18n.password")'
    width="400px"
    :close-on-click-modal="false"
    @close="handleClose"
    append-to-body
  >
    <div class="mag-box">
      <el-form :model="safeForm" :rules="rules" ref="safeFormRef">
        <el-form-item
          v-if='editType === "手机"'
          :label="$t('accountI18n.phone')"
          prop="phone"
        >
          <el-input
            v-model="safeForm.phone"
            :placeholder="$t('accountI18n.phonePlaceholder')"
            maxlength="11"
          />
        </el-form-item>
        <el-form-item
          v-if='editType === "邮箱"'
          :label="$t('accountI18n.email')"
          prop="email"
        >
          <el-input
            v-model="safeForm.email"
            :placeholder="$t('accountI18n.emailPlaceholder')"
          />
        </el-form-item>
        <el-form-item
          v-if='editType === "密码"'
          :label="$t('accountI18n.password')"
          prop="password"
        >
          <el-input
            v-model="safeForm.password"
            type="password"
            :placeholder="$t('accountI18n.passwordPlaceholder')"
          />
        </el-form-item>
        <el-form-item 
          :label="$t('accountI18n.code')" 
          prop="code" 
          v-if="editType !== '密码'"
        >
          <div class="justify-between">
            <el-input
              v-model="safeForm.code"
              :placeholder="$t('accountI18n.codePlaceholder')"
              maxlength="6"
            />
            <el-button
              :disabled="countdown > 0"
              @click="sendCode"
              style="margin-left: 10px;"
            >
              {{ countdown > 0 ? `${countdown}s ${$t('accountI18n.reSendCode')}` : $t('accountI18n.codeSend') }}
            </el-button>
          </div>
        </el-form-item>
      </el-form>
    </div>
    <span slot="footer" class="dialog-footer">
      <el-button @click="handleClose">{{$t('accountI18n.cancel')}}</el-button>
      <el-button type="primary" @click="submitCode">{{$t('accountI18n.confirm')}}</el-button>
    </span>
  </el-dialog>
</template>

<script>
import { mapState } from "vuex";
import { sendVerifyCode, updateAccount, sendEmailCode, logoutApi, forgetPassword } from '@/api/index';
import { handleLogout } from '@/utils/request';
export default {
  name: "SafeValiate",
  props: {
    editType: { //编辑类型 1: 手机号, 2: 邮箱, 3: 密码
      type: String,
      required: false
    },
    validationType: { //验证类型 1: 手机号, 2: 邮箱
      type: String,
      required: false
    },
    validationValue: {
      type: String,
      required: false
    },
    editValiate: {
      type: Boolean,
      required: true
    },
    newValidation:{
      type: String,
      required: false
    },
    phoneOrEmail: {
      type: String,
      required: false
    }
  },
  data() {
    // 校验规则
    const phoneValidator = (rule, value, callback) => {
      if (!value || !/^1\d{10}$/.test(value)) {
          callback(new Error(this.$t('accountI18n.phoneError')));
        } else {
          callback();
        }
    };
    const codeValidator = (rule, value, callback) => {
      if (!value || value.length !== 6) {
        callback(new Error(this.$t('accountI18n.codeError')));
      } else {
        callback();
      }
    };
    const emailValidator = (rule, value, callback) => {
      if (!value ||!/^[A-Za-z0-9._%+-]+@[A-Za-z0-9.-]+\.[A-Za-z]{2,}$/.test(value)) {
        callback(new Error(this.$t('accountI18n.emailError'))); 
      } else {
        callback();
      } 
    }
    return {
      safeForm: {
        phone: "",
        code: "",
        email: "",
        password: ""
      },
      countdown: 0,
      timer: null,
      rules: {
        phone: [{ validator: phoneValidator, trigger: "blur" }],
        email: [{ validator: emailValidator, trigger: "blur" }],
        code: [{ validator: codeValidator, trigger: "blur" }],
        password: [{ required: true, message: this.$t('accountI18n.passwordError'), trigger: "blur" }]
      }
    };
  },
  computed: {
    ...mapState(["userInfo"]),
  },
  methods: {
    // 发送验证码
    sendCode() {
      if(this.editType === "手机"){
        this.$refs.safeFormRef.validateField("phone", errorMessage => {
          if (errorMessage) return;
          sendVerifyCode({ 
              phone: this.safeForm.phone
          }).then(res => {
            if (res.data.code == 200) {
              this.countdown = 60;
              if (this.timer) clearInterval(this.timer);
              this.timer = setInterval(() => {
              this.countdown--;
              if (this.countdown <= 0) {
                  clearInterval(this.timer);
                  this.timer = null;
              }
              }, 1000);
              this.$message.success(this.$t('accountI18n.codeSendSuccess'));
            } else {
              this.$message.error(this.$t('accountI18n.codeSendError'));
            }
          }).catch(err => {
            this.$message.error(err || this.$t('accountI18n.codeSendError'));
          })
        });
      }else{
        this.$refs.safeFormRef.validateField("email", errorMessage => {
          if (errorMessage) return;
          sendEmailCode({ 
              email: this.safeForm.email
          }).then(res => {
            if (res.data.code == 200) {
              this.countdown = 60;
              if (this.timer) clearInterval(this.timer);
              this.timer = setInterval(() => {
              this.countdown--;
              if (this.countdown <= 0) {
                  clearInterval(this.timer);
                  this.timer = null;
              }
              }, 1000);
              this.$message.success(this.$t('accountI18n.codeSendSuccess'));
            } else {
              this.$message.error(this.$t('accountI18n.codeSendError'));
            }
          }).catch(err => {
            this.$message.error(err || this.$t('accountI18n.codeSendError'));
          })
        });
      }
    },
    // 提交修改
    submitCode() {
      // const validation = this.validationType === "1" ? this.userInfo?.phone : this.userInfo?.email;
      this.$refs.safeFormRef.validate(valid => {
        if (!valid) return;
        if(this.editType === "手机"){
          updateAccount({
            phone: this.safeForm.phone,
            security_code: this.safeForm.code,
            validation: this.validationValue
          }).then(res => {
            if (res.data.code == 200) {
              this.$message.success(this.$t('accountI18n.phoneSuccess'));
              this.$emit("success");
              this.reset();
            } else {
              this.$message.error(this.$t('accountI18n.updateError'));
            }
          }).catch(err => {
            this.$message.error(err || this.$t('accountI18n.updateError')); 
          })
        }else if(this.editType === "邮箱"){
          updateAccount({
            email: this.safeForm.email,
            security_code: this.safeForm.code,
            validation: this.validationValue
          }).then(res => {
            if (res.data.code == 200) {
              this.$message.success(this.$t('accountI18n.updateSuccess'));
              this.$emit("success");
              this.reset();
            } else {
              this.$message.error(res.data.msg);
            }
          }).catch(err => {
            this.$message.error(err || this.$t('accountI18n.updateError')); 
          })
        }else{
          if(!this.userInfo){
            forgetPassword(this.phoneOrEmail, {
              password: this.safeForm.password,
              validation: this.newValidation 
            }).then(res => {
              if (res.data.code == 200) {
                this.$message.success(this.$t('accountI18n.updateSuccess'));
                this.$emit("closeEpp");
              } else {
                this.$message.error(res.data.msg);
              }
            }).catch(err => {
              this.$message.error(err || this.$t('accountI18n.updateError'));
            })
          }else{
            updateAccount({
              password: this.safeForm.password,
              validation: this.validationValue
            }).then(res => {
              if (res.data.code == 200) {
                this.$message.success(this.$t('accountI18n.updateSuccess'));
                setTimeout(() => {
                  logoutApi().then((res) => {
                    if (res.data.code === 200) {
                      handleLogout(); // 调用公共方法
                      setTimeout(() => {
                        window.location.reload(); // 刷新页面 
                      }, 1000)
                    } else {
                      this.$message.error(res.data.msg);
                    }
                  }).catch((error) => {
                    this.$message.error(error || this.$t('accountI18n.logoutError'));
                  });
                }, 1000);
              } else {
                this.$message.error(res.data.msg);
              }
            }).catch(err => {
              this.$message.error(err || this.$t('accountI18n.updateError')); 
            })
          }
        }
      });
    },
    // 关闭弹窗
    handleClose() {
      this.$emit("closeEpp");
      this.reset();
    },
    // 重置状态
    reset() {
      this.$refs.safeFormRef.resetFields();
      if (this.timer) {
        clearInterval(this.timer);
        this.timer = null;
      }
      this.countdown = 0;
    }
  },
  beforeDestroy() {
    if (this.timer) clearInterval(this.timer);
  }
};
</script>